import { linkFitsPlayMode, songFitsPlayMode, type PlayModeConfig } from '../services/playModes';
import type { createRequest, SongRequest } from '../services/requests';
import type { LibraryLink, LibrarySong, LinkProvider } from '../services/songMatchMemory';

type CreateRequestData = Parameters<typeof createRequest>[1];

const PROVIDERS: LinkProvider[] = ['spotify', 'tidal', 'apple'];

function pickLink(song: LibrarySong, mode: PlayModeConfig): LibraryLink | undefined {
  const modeLink = song.links[mode.provider];
  if (modeLink) return modeLink;
  const links = PROVIDERS.flatMap(provider => song.links[provider] ?? []);
  return links.find(link => linkFitsPlayMode(link.url, link.platformName, mode)) ?? links[0];
}

export function libraryRequestData(librarySong: LibrarySong, djUid: string, mode: PlayModeConfig): CreateRequestData {
  const link = pickLink(librarySong, mode);
  const linkFits = linkFitsPlayMode(link?.url, link?.platformName, mode);
  const song: SongRequest['song'] = {
    title: librarySong.title,
    artist: librarySong.artist,
    explicitFlag: false,
    albumArtUrl: link?.albumArtUrl || undefined,
    durationMs: link?.durationMs || undefined,
    itunesTrackId: librarySong.appleId ?? undefined,
    isrc: librarySong.isrc ?? null,
  };
  const fits = linkFits || songFitsPlayMode({ song }, mode);
  return {
    song,
    requestedBy: { oderId: djUid, nickname: 'DJ' },
    initialStatus: fits ? 'queued' : 'pending',
    ...(linkFits && link
      ? {
          platformLink: link.url,
          platformName: link.platformName || undefined,
          songLinkUrl: link.songLinkUrl || undefined,
        }
      : {}),
    durationVerified: link?.durationVerified || undefined,
    entrySource: 'dj-added',
    matchVerified: fits,
  };
}
